import type { VoidFunctionComponent } from 'react';
import type Stripe from 'stripe-latest';
import { getLimitDisplayValue, isEnterprisePlan } from './utils';
import { GreenCheck } from '../../generic';
import { ICON_SIZE } from '../../generic/Icon/icon-constants';
import Flex from '../../generic/Flex';
import styles from './style.module.less';

type LimitsComponentProps = {
  product: Stripe.Product,
};

const getLimitsTitle = (product: Stripe.Product) => {
  if (isEnterprisePlan(product)) {
    return 'No limits';
  }
  return 'Limits';
};

const LimitsComponent: VoidFunctionComponent<LimitsComponentProps> = ({
  product,
}) => {
  const limits = [
    {
      label: 'projects',
      value: getLimitDisplayValue(product?.metadata?.limit_projects),
    },
    {
      label: 'contributing developers',
      value: getLimitDisplayValue(product?.metadata?.limit_contributors),
    },
    {
      label: 'release groups',
      value: getLimitDisplayValue(product?.metadata?.limit_release_groups),
    },
    {
      label: 'dependency depth for scans',
      value: getLimitDisplayValue('unlimited'),
    },
    {
      label: 'Fully unlocked quality checks',
      value: '',
    },
    {
      label: 'imported SBOMs',
      value: getLimitDisplayValue(product?.metadata?.limit_projects),
    },
  ];

  return (
    <div className={styles.limitsContainer}>
      <div className={styles.limitsTitle}>
        {getLimitsTitle(product)}
      </div>
      {limits.map((limit) => {
        return (
          <div key={limit.label} className={styles.limitItem}>
            <Flex justify="flex-start" align="flex-start" gap={12}>
              <GreenCheck size={ICON_SIZE.LG} />
              <div>{limit.value} {limit.label}</div>
            </Flex>
          </div>
        );
      })}
    </div>
  );
};

type LimitsComponentForStaticPlanProps = {
  list: string[],
};
export const LimitsComponentForStaticPlan: VoidFunctionComponent<LimitsComponentForStaticPlanProps> = ({
  list,
}) => {
  return (
    <div className={styles.limitsContainer}>
      <div className={styles.limitsTitle}>
        Details
      </div>
      {list.map((item) => {
        return (
          <div key={item} className={styles.limitItem}>
            <Flex justify="flex-start" align="flex-start" gap={12}>
              <GreenCheck size={ICON_SIZE.LG} />
              <div>{item}</div>
            </Flex>
          </div>
        );
      })}
    </div>
  );
};

export default LimitsComponent;
